<template>
  <div class="verification-code-input">
    <div 
      v-for="(item, index) in length" 
      :key="index"
      class="input-item"
    >
      <input
        ref="inputs"
        v-model="codeArray[index]"
        type="text"
        inputmode="numeric"
        :class="{ 'error': hasError }"
        placeholder=""
        pattern="[0-9]*"
        maxlength="1"
        :disabled="index > 0 && !codeArray[index - 1]"
        @input="handleInput($event, index)"
        @keydown="handleKeydown($event, index)"
        @paste="handlePaste"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerificationCodeInput',
  props: {
    // 验证码长度
    length: {
      type: Number,
      default: 4
    },
    // 初始值
    value: {
      type: String,
      default: ''
    },
    // 校验错误状态
    hasError: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      codeArray: new Array(this.length).fill('')
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.codeArray = val.split('').slice(0, this.length)
        }
      }
    }
  },
  methods: {
    // 处理输入
    handleInput(event, index) {
      const value = event.target.value
      // 只允许输入数字
      if (!/^\d*$/.test(value)) {
        this.codeArray[index] = ''
        return
      }

      // 更新当前输入框的值
      this.codeArray[index] = value

      // 如果当前输入框有值，且不是最后一个，则自动聚焦下一个
      if (value && index < this.length - 1) {
        this.$nextTick(() => {
          this.$refs.inputs[index + 1].focus()
        })
      }

      // 触发 v-model 更新
      this.$emit('input', this.codeArray.join(''))
      this.$emit('change', this.codeArray.join(''))
    },

    // 处理键盘事件
    handleKeydown(event, index) {
      // 处理退格键
      if (event.key === 'Backspace') {
        if (!this.codeArray[index] && index > 0) {
          // 如果当前输入框为空，且不是第一个，则删除前一个输入框的值并聚焦
          this.codeArray[index - 1] = ''
          this.$nextTick(() => {
            this.$refs.inputs[index - 1].focus()
          })
          this.$emit('input', this.codeArray.join(''))
          this.$emit('change', this.codeArray.join(''))
        }
      }
      // 处理左箭头键
      else if (event.key === 'ArrowLeft' && index > 0) {
        this.$nextTick(() => {
          this.$refs.inputs[index - 1].focus()
        })
      }
      // 处理右箭头键
      else if (event.key === 'ArrowRight' && index < this.length - 1) {
        this.$nextTick(() => {
          this.$refs.inputs[index + 1].focus()
        })
      }
    },

    // 处理粘贴事件
    handlePaste(event) {
      event.preventDefault()
      const pastedData = event.clipboardData.getData('text')
      const numbers = pastedData.replace(/[^\d]/g, '').split('').slice(0, this.length)
      
      // 填充粘贴的数字
      numbers.forEach((num, index) => {
        if (index < this.length) {
          this.codeArray[index] = num
        }
      })

      // 聚焦到最后一个有值的输入框的下一个
      const lastFilledIndex = numbers.length - 1
      if (lastFilledIndex < this.length - 1) {
        this.$nextTick(() => {
          this.$refs.inputs[lastFilledIndex + 1].focus()
        })
      }

      this.$emit('input', this.codeArray.join(''))
      this.$emit('change', this.codeArray.join(''))
    },

    // 清空输入
    clear() {
      this.codeArray = new Array(this.length).fill('')
      this.$emit('input', '')
      this.$emit('change', '')
      this.$nextTick(() => {
        this.$refs.inputs[0].focus()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.verification-code-input {
  display: flex;
  justify-content: center;

  .input-item {
    background: #F5F5F7;
    border-radius: 28.25px;
    margin-right: 16px;

    input {
      width: 64px;
      height: 80px;
      border: none;
      border-radius: 28.25px;
      text-align: center;
      font-family: DiDiSans-Pro-Regular;
      font-size: 48px;
      color: #0B0B0D;
      letter-spacing: 0;
      line-height: 56px;
      font-weight: 400;
      background-color: #F5F5F7;
      transition: all 0.3s;

      &:focus {
        border-color: #42b983;
        outline: none;
      }

      &:disabled {
        background-color: #f5f5f5;
        cursor: not-allowed;
      }

      // 已输入状态
      &:not(:placeholder-shown) {
        border: 2px solid #0C0C0D;
        border-radius: 24px;
        background: #F5F5F7;
      }

      // 校验错误状态
      &.error {
        width: 64px;
        height: 80px;
        background: #FFFFFF;
        border: 2px solid #FF1965;
        border-radius: 24px;
      }
    }
  }
}
</style> 